import React from "react"
import ParentScreen from "../ParentScreen"
import {
  getUser,
  logout,
  setActiveClass,
  updateGender,
  updateLocalClasses,
} from "../../../helpers/AuthHelper"
import { SettingsComponents } from "../../../components"
import { history } from "../../../history"
import { getClasses } from "../../../network/providers/classProvider"

export default class Authorization extends ParentScreen {
  constructor(props) {
    super(props)
    this.userTR = getUser()
    if (!this.userTR) {
      logout()
    } else {
      this.user = JSON.parse(this.userTR).user
      if (
        this.user?.class === undefined &&
        history.location.pathname !== "/" &&
        history.location.pathname !== "/success"
      ) {
        history.push("/")
      } else {
        try {
          if (
            this.user?.gender !== "M" &&
            this.user?.gender !== "F" &&
            this.user?.gender !== "X"
          )
            updateGender()
        } catch (error) {
          logout()
        }
      }
    }
  }

  async componentDidMount() {
    await super.componentDidMount()
    const classes = await getClasses()
    updateLocalClasses(classes, () => {
      setActiveClass(this.user?.class?.id)
      this.setState({ classes, activeClass: this.user?.class?.id })
    })
  }

  updateContextUser(user) {
    let finalUser = JSON.parse(this.userTR)
    finalUser.user = user
    this.userTR = JSON.stringify(finalUser)
    this.user = user
  }

  renderModals() {
    let modals = super.renderModals()
    modals.push(
      <SettingsComponents
        key="settings"
        userTR={this.userTR}
        visible={this.state.settingsModalVisible}
        closeSettings={() => this.setState({ settingsModalVisible: false })}
      />
    )
    return modals
  }
}
